/* eslint-disable react/no-deprecated, @typescript-eslint/no-var-requires,@typescript-eslint/no-explicit-any */

// React 16 moved these out of core - some dependencies require them
// NB. using require instead of import to avoid misisng types failing builds - we don't use them directly
export const patchReact16 = () => {
  const createClass = require("create-react-class");
  const PropTypes = require("prop-types");
  const DOM = require("react-dom-factories");
  const React = require("react");
  
  React.createClass = createClass; // Required by react-datetime
  React.PropTypes = PropTypes; // Required by armstrong form and others
  React.DOM = DOM; // Required by react-datetime
};
